import { composeSelector } from "seneca-common/utils/selectors/compose-selectors";

import { getMemoriesStateSlice } from "./";
import { getMetaSlice } from "./state";
import * as meta from "./state/meta";

type State = any;

function getMetaState(state: State) {
  return getMetaSlice(getMemoriesStateSlice(state));
}

// fetch
export const memoriesAreFetching: (arg0: State) => boolean = composeSelector(
  getMetaState,
  meta.memoriesAreFetching
);

export const memoriesFetchSucceeded: (arg0: State) => boolean = composeSelector(
  getMetaState,
  meta.memoriesFetchSucceeded
);

export const memoriesFetchErrored: (arg0: State) => boolean = composeSelector(
  getMetaState,
  meta.memoriesFetchErrored
);

export const memoriesFetchFinished: (arg0: State) => boolean = composeSelector(
  getMetaState,
  meta.memoriesFetchFinished
);

export const memoriesNeedFetching: (arg0: State) => boolean = composeSelector(
  getMetaState,
  meta.memoriesNeedFetching
);
